import { Component, Input } from '@angular/core';
import { WellRequest } from 'src/app/model/well-request.model';

@Component({
    selector: 'app-well-details-info',
    templateUrl: './well-details-info.component.html',
    styleUrls: ['../well-details.component.css'],
    standalone: false
})
export class WellDetailsInfoComponent {
  @Input()
  wellRequest!: WellRequest | undefined;

  getDrillingType(wellRequest?: WellRequest) {
    if (!!(wellRequest?.rigDrillType))
      return wellRequest?.rigDrillType;

    return wellRequest?.manualRigType
  }

  getRigOwner(wellRequest?: WellRequest) {
    if (!!(wellRequest?.rigOwner))
      return wellRequest?.rigOwner;

    return wellRequest?.manualRigOwner
  }

  getRigSource(wellRequest?: WellRequest) {
    let hasManualField = !!(wellRequest?.manualRigType) || !!(wellRequest?.manualRigOwner)

    if (wellRequest?.rigSource == "Enverus" && hasManualField)
      return "Enverus, LOGIX™"
    return wellRequest?.rigSource
  }
}
